import { useState } from "react";

const faqs = [
  {
    id: 1,
    category: "유지보수 & 운영",
    q: "납품 후 유지보수는 어떻게 되나요?",
    a: "유지보수(버그 수정, 기능 추가, 서버 관리 등)는 수익 쉐어형·개발비 직접결제형 모두 플랜 비용에 포함되지 않으며, 납품 이후 별도 계약으로 진행됩니다. 월정액 리테이너 방식 또는 건별 처리 방식 중 협의하여 선택할 수 있습니다.",
    icon: "ri-tools-line",
    color: "#14F1D9",
  },
  {
    id: 2,
    category: "유지보수 & 운영",
    q: "OPEX(운영 실비)는 얼마나 나오나요?",
    a: "서비스 규모에 따라 다르지만 일반적으로 월 3–15만원 수준의 클라우드 인프라·도메인·결제 수수료 등이 발생합니다. 아르트레너는 마진 없이 영수증 기반으로 100% 투명하게 실비만 정산(Pass-through)합니다. OPEX는 수익 쉐어율과 무관한 별도 항목입니다.",
    icon: "ri-server-line",
    color: "#14F1D9",
  },
  {
    id: 3,
    category: "계약 & 비용",
    q: "계약 기간은 어떻게 되나요?",
    a: "수익 쉐어형은 최소 12개월 협력을 기준으로 하며, 성과에 따라 장기 파트너십으로 이어집니다. 개발비 직접결제형은 프로젝트 납품 시점에 계약이 완료되고, 이후 유지보수가 필요하면 별도 계약을 체결합니다.",
    icon: "ri-calendar-check-line",
    color: "#A855F7",
  },
  {
    id: 4,
    category: "계약 & 비용",
    q: "개발비는 분할 납부가 가능한가요?",
    a: "네, 직접결제형의 경우 착수금(30%) + 중도금(40%) + 잔금(30%) 형태의 3회 분할 납부를 기본으로 제공합니다. 프로젝트 규모와 상황에 따라 일정 조정도 협의 가능합니다.",
    icon: "ri-money-dollar-circle-line",
    color: "#A855F7",
  },
  {
    id: 5,
    category: "수익 쉐어",
    q: "수익 쉐어는 언제부터 시작되나요?",
    a: "실제 수익이 발생하는 시점부터 적용됩니다. 런칭 전 개발 기간이나 수익이 발생하지 않는 기간에는 수익 쉐어가 청구되지 않습니다. 쉐어 기준(매출 or 순익)과 정산 주기는 계약서에 명시됩니다.",
    icon: "ri-percent-line",
    color: "#F97316",
  },
  {
    id: 6,
    category: "수익 쉐어",
    q: "수익 쉐어형에서 '풀 플랫폼 개발 기본'이란 무슨 의미인가요?",
    a: "수익 쉐어형은 싱글/멀티/풀 규모 구분 없이 아티스트에게 필요한 수준의 플랫폼을 투자·공동투자 형태로 구축해드립니다. 직접결제형처럼 '범위에 따른 추가 비용'이 발생하지 않으며, 필요한 솔루션의 규모는 진단 결과와 플랜에 따라 함께 설계합니다.",
    icon: "ri-stack-line",
    color: "#F97316",
  },
  {
    id: 7,
    category: "소유권 & 해지",
    q: "완성된 결과물의 소유권은 누구에게 있나요?",
    a: "직접결제형은 잔금 완납 즉시 코드·디자인·도메인 등 모든 결과물의 소유권이 아티스트에게 완전히 이전됩니다. 수익 쉐어형은 협력 기간 동안 공동 관리하며, 계약 종료 시 투자 정산 조건에 따라 소유권 이전이 가능합니다.",
    icon: "ri-key-2-line",
    color: "#14F1D9",
  },
  {
    id: 8,
    category: "소유권 & 해지",
    q: "중도에 플랜을 변경하거나 해지할 수 있나요?",
    a: "수익 쉐어형은 중도 해지 시 투자 비용 일부 정산 및 결과물 소유권 이전 조건을 계약서에 미리 명시합니다. 직접결제형은 진행 단계별 정산 후 중단이 가능합니다. 수익 쉐어형 → 직접결제형 전환도 별도 협의를 통해 가능합니다.",
    icon: "ri-contract-left-line",
    color: "#A855F7",
  },
];

const categories = ["유지보수 & 운영", "계약 & 비용", "수익 쉐어", "소유권 & 해지"];

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(null);
  const [activeCategory, setActiveCategory] = useState<string>("전체");

  const filtered = activeCategory === "전체" ? faqs : faqs.filter((f) => f.category === activeCategory);

  return (
    <section id="faq" className="relative py-24 lg:py-36 px-6 bg-brand-bg overflow-hidden">
      {/* BG */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] rounded-full opacity-[0.04]"
          style={{ background: "radial-gradient(circle, #A855F7 0%, transparent 70%)" }} />
      </div>

      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 lg:mb-16">
          <span className="inline-block text-xs font-display font-medium tracking-widest uppercase text-brand-purple mb-5 px-3 py-1 rounded-full border border-brand-purple/30 bg-brand-purple/5">
            FAQ
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-white leading-snug">
            자주 묻는 질문
          </h2>
          <p className="mt-4 text-white/45 font-body text-base max-w-md mx-auto leading-loose">
            계약·유지보수·소유권에 대한 주요 궁금증을 정리했어요.
          </p>
        </div>

        {/* Category filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {["전체", ...categories].map((cat) => (
            <button
              key={cat}
              onClick={() => { setActiveCategory(cat); setOpenId(null); }}
              className="px-4 py-2 rounded-full text-xs font-display font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
              style={
                activeCategory === cat
                  ? { background: "linear-gradient(135deg, #A855F7, #7C3AED)", color: "#fff", boxShadow: "0 0 12px rgba(168,85,247,0.3)" }
                  : { background: "rgba(255,255,255,0.05)", color: "rgba(255,255,255,0.45)", border: "1px solid rgba(255,255,255,0.08)" }
              }
            >
              {cat}
            </button>
          ))}
        </div>

        {/* FAQ list */}
        <div className="flex flex-col gap-3">
          {filtered.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div
                key={faq.id}
                className="rounded-2xl overflow-hidden transition-all duration-300"
                style={{
                  border: isOpen ? `1px solid ${faq.color}30` : "1px solid rgba(255,255,255,0.07)",
                  background: isOpen ? `rgba(255,255,255,0.03)` : "rgba(13,17,32,0.6)",
                }}
              >
                <button
                  onClick={() => setOpenId(isOpen ? null : faq.id)}
                  className="w-full flex items-center gap-4 px-6 py-5 text-left cursor-pointer"
                >
                  <div
                    className="w-9 h-9 flex items-center justify-center rounded-xl flex-shrink-0 transition-all duration-300"
                    style={{ background: isOpen ? `${faq.color}18` : "rgba(255,255,255,0.05)" }}
                  >
                    <i className={`${faq.icon} text-sm`} style={{ color: isOpen ? faq.color : "rgba(255,255,255,0.3)" }} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="text-xs font-body font-medium mr-3" style={{ color: isOpen ? faq.color : "rgba(255,255,255,0.3)" }}>
                      {faq.category}
                    </span>
                    <p className={`text-sm font-display font-semibold mt-0.5 ${isOpen ? "text-white" : "text-white/75"} transition-colors`}>
                      {faq.q}
                    </p>
                  </div>
                  <div
                    className="w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300"
                    style={{ background: isOpen ? `${faq.color}18` : "rgba(255,255,255,0.05)", transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}
                  >
                    <i className="ri-arrow-down-s-line text-sm" style={{ color: isOpen ? faq.color : "rgba(255,255,255,0.3)" }} />
                  </div>
                </button>

                {/* Answer */}
                <div
                  className="overflow-hidden transition-all duration-300"
                  style={{ maxHeight: isOpen ? "300px" : "0px", opacity: isOpen ? 1 : 0 }}
                >
                  <div className="px-6 pb-6 pt-0">
                    <div className="pl-13 ml-0" style={{ paddingLeft: "52px" }}>
                      <div className="w-full h-px mb-4" style={{ background: `linear-gradient(to right, ${faq.color}30, transparent)` }} />
                      <p className="text-sm text-white/60 font-body leading-loose">{faq.a}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div
          className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-5 p-6 lg:p-8 rounded-3xl"
          style={{ background: "linear-gradient(135deg, rgba(168,85,247,0.1) 0%, rgba(6,8,15,0.6) 100%)", border: "1px solid rgba(168,85,247,0.2)" }}
        >
          <div>
            <p className="font-display font-bold text-white text-lg mb-1">더 궁금한 점이 있으신가요?</p>
            <p className="text-sm text-white/45 font-body">빌더팀이 직접 답변드릴게요. 진단을 완료하면 48시간 내 연락드립니다.</p>
          </div>
          <a
            href="/diagnosis"
            className="flex items-center gap-2 px-6 py-3 rounded-full text-sm font-display font-semibold text-white whitespace-nowrap cursor-pointer flex-shrink-0 transition-all"
            style={{ background: "linear-gradient(135deg, #A855F7, #7C3AED)", boxShadow: "0 0 20px rgba(168,85,247,0.3)" }}
          >
            아르트레너 진단 시작하기
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}
